module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-36.0ea7b74d.png";